<script lang="ts" setup>
// -------------------------------
// 🔹 Imports Vue & composables
// -------------------------------
import { form, isLoaderLoginFormActivated } from '../../refs/login.form.refs';
import { isCategoryActivated } from '@/refs/categories.refs';
import MultiSelect from 'primevue/multiselect';

// -------------------------------
// 🔹 Composants
// -------------------------------
import TextInput from '../common/BaseInput.vue';
import BaseButtonPrimary from '../common/BaseButtonPrimary.vue';

// -------------------------------
// 🔹 Refs & données
// -------------------------------
import { idToDelete } from '@/refs/commerce.refs';
import { isGlobalError, restauantIdVal } from '@/refs/common.refs';

// -------------------------------
// 🔹 Mutations / services
// -------------------------------
import { UserMutation } from '@/mutations/user.mutation';
import {
  form_Client_user_Body,
  form_user_Body,
  form_user_Body_update,
  isAtcivatedWatch,
  isAtcivatedWatchUser,
  roleId,
} from '@/refs/user.refs';
import { useQuery } from '@tanstack/vue-query';
import { useCommerceStore } from '@/store/commerce.store';
import { useUserStore } from '@/store/user.store';
const { handleCreateUser, assignUserRole } = UserMutation();

// -------------------------------
// 🔹 Émission d’événements
// -------------------------------
const emit = defineEmits<{
  (e: 'HandleClose'): void;
}>();

// -------------------------------
// 🔹 Stores instanciés
// -------------------------------
const commerceStore = useCommerceStore();
const userCustomerStore = useUserStore();
const {
  data: dataGetCommerces,
  isLoading: isLoadingGetCommerces,
  isError: isErrorGetCommerces,
  refetch: refectGetCommerces,
} = useQuery({
  queryKey: ['GetCommerces'],
  queryFn: () => commerceStore.getCommerces(),
});
const {
  data: dataGetAvailablePermission,
  isLoading: isLoadingGetAvailablePermission,
  isError: isErrorGetAvailablePermission,
  refetch: refectGetAvailablePermission,
} = useQuery({
  queryKey: ['GetAvailableRole'],
  queryFn: () => userCustomerStore.getUserStaffRole(),
});
// -------------------------------
// 🔹 Gestion du formulaire
// -------------------------------

/**
 * Soumet le formulaire de création de commerce.
 * Gère les différentes étapes : création du commerce, ajout du contact, ou upload du logo.
 */
const handleSubmit = async () => {
  isLoaderLoginFormActivated.value = true;

  try {
    const res = await assignUserRole({
      assignments: roleId.value.map((role) => ({
        restaurantId: form_user_Body.restaurantId,
        roleId: role,
      })),
    });

    if (res) {
      setTimeout(() => {
        isAtcivatedWatchUser.value = !isAtcivatedWatchUser.value;
        isLoaderLoginFormActivated.value = false;
        handleClose();
      }, 1000);
    }
  } catch (error) {
    isGlobalError.value = true;
    setTimeout(() => {
      isLoaderLoginFormActivated.value = false;
      isGlobalError.value = false;
    }, 1000);
  }
};

/**
 * Ferme le formulaire et réinitialise l’ID à supprimer.
 */
const handleClose = (): void => {
  idToDelete.value = null;
  emit('HandleClose');
};
</script>

<template>
  <form
    autocomplete="on"
    accept-charset="UTF-8"
    @submit.prevent="handleSubmit"
    class="space-y-6"
  >
    <div class="space-y-[16px]">
      <div class="flex w-full flex-1 flex-col gap-2">
        <label for="commerce" class="mb-1 block font-medium text-gray-700">
          Sélectionnez le commerce
          <span class="text-decroissance text-14px leadinspanrmal">*</span>
        </label>
        <select
          id="commerce"
          name="commerce_associé"
          v-model="form_user_Body.restaurantId"
          required
          class="border-border-input focus:ring-primary-900 focus:border-primary-900 w-full rounded-xl border bg-white px-3 py-2 text-sm text-gray-700 placeholder-gray-400 shadow-sm transition-all outline-none hover:border-gray-400 focus:ring-2"
        >
          <option value="" disabled>Veuillez sélectionner un commerce</option>
          <option
            v-for="value in dataGetCommerces?.data"
            :value="value?.id"
            class="text-14px text-secondary-text"
          >
            {{ value.designation }}
          </option>
        </select>
      </div>
      <div class="flex w-full flex-1 flex-col gap-2">
        <label for="commerce" class="mb-1 block font-medium text-gray-700">
          Sélectionnez les rôles
          <span class="text-decroissance text-14px leadinspanrmal">*</span>
        </label>

        <MultiSelect
          v-model="roleId"
          :options="dataGetAvailablePermission?.data"
          option-label="code"
          option-value="id"
          placeholder="Sélectionnez les rôles"
          class="w-full"
        />
      </div>
    </div>

    <div class="invisible h-[50px]" />

    <div class="fixed bottom-0 left-0 w-full bg-white py-6">
      <div class="flex flex-row items-center justify-between gap-8 px-[16px]">
        <div class="w-full">
          <BaseButtonPrimary
            type="submit"
            :isClicked="isLoaderLoginFormActivated"
            label="Assigner le(s) rôle(s) au user"
            style_of_btn="primary_color_of_btn "
            class="w-full text-white"
          />
        </div>

        <div class="w-full" @click="handleClose">
          <BaseButtonPrimary
            type="button"
            label="Annuler"
            style_of_btn="secondary_color_of_btn "
            class="text-grand-text w-full"
          />
        </div>
      </div>
    </div>
  </form>
</template>
